(function (Drupal, Swiper) {
  Drupal.behaviors.newsScroller = {
    attach(context) {
      once('newsScroller', '.news-slider', context).forEach(function (element) {
        new Swiper(element, {
          spaceBetween: 32,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 32,
            },
            768: {
              pagination: false,
              slidesPerView: 2,
              spaceBetween: 16
            },
            992: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 32
            },
          },
        });
      });
    },
  };
})(Drupal, Swiper);
